import Axios from 'axios';

Axios.defaults.headers.common.Accept = 'application/json';

const baseURL = process.env.SERVER_HOST || 'http://dev001-ac3soowu.lifecare-tobana.com';
const clientId = process.env.CLIENT_ID || 1;
const clientKey = process.env.CLIENT_KEY || '6WTTOpTBztisZ27QNeyKZ6OfAoSfqS2BsdUBz92G';
export const snippetsURL = `${baseURL}/api/contentbox_snippets`;

const getWithToken = async (
  token, { url, headers, config, isError, wrap, rescue, rescueWrap }) => {
  const getConfig = {
    headers: {
      'content-type': 'application/json',
      authorization: `Bearer ${token}`,
      ...headers,
    },
    ...config,
  };
  try {
    const { status, data } = await Axios.get(url, getConfig);
    if (isError(status, data)) {
      return undefined;
    }
    if (wrap === undefined) {
      return data;
    }
    return wrap(data, status);
  } catch (e) {
    const { response } = e;
    if (response) {
      const { status, data } = response;
      if (rescue && rescue(status, data)) {
        if (rescueWrap === undefined) {
          return data;
        }
        return rescueWrap(data, status);
      }
    }
    window.console.log(e);
    return undefined;
  }
};

const postWithToken = async (
  token, { url, headers, config, body, isError, wrap, rescue, rescueWrap }) => {
  const postConfig = {
    headers: {
      'content-type': 'application/json',
      authorization: `Bearer ${token}`,
      ...headers,
    },
    ...config,
  };
  try {
    const { status, data } = await Axios.post(url, body, postConfig);
    if (isError(status, data)) {
      return undefined;
    }
    if (wrap === undefined) {
      return data;
    }
    return wrap(data, status);
  } catch (e) {
    const { response } = e;
    if (response) {
      const { status, data } = response;
      if (rescue && rescue(status, data)) {
        if (rescueWrap === undefined) {
          return data;
        }
        return rescueWrap(data, status);
      }
    }
    window.console.log(e);
    return undefined;
  }
};

export default class Requests {
  accessToken = undefined;
  adminToken = undefined;
  constructor(accessToken, adminToken) {
    this.accessToken = accessToken;
    this.adminToken = adminToken;
  }
  async getWithAuth(payload) {
    if (!this.accessToken) {
      return undefined;
    }
    return getWithToken(this.accessToken, payload);
  }
  async getWithAdmin(payload) {
    if (!this.adminToken) {
      return undefined;
    }
    return getWithToken(this.adminToken, payload);
  }
  async postWithAuth(payload) {
    if (!this.accessToken) {
      return undefined;
    }
    return postWithToken(this.accessToken, payload);
  }
  async postWithAdmin(payload) {
    if (!this.adminToken) {
      return undefined;
    }
    return postWithToken(this.adminToken, payload);
  }
  async login(username, password) {
    const loginURL = `${baseURL}/oauth/token`;
    const loginConfig = {
      headers: {
        'content-type': 'application/json',
      },
    };
    const loginPayload = {
      client_id: clientId,
      client_secret: clientKey,
      username,
      password,
      grant_type: 'password',
      scope: '*',
    };
    try {
      const { status, data } = await Axios.post(loginURL, loginPayload, loginConfig);
      if (status !== 200 || !data || !('access_token' in data)) {
        return false;
      }
      this.accessToken = data.access_token;
      return true;
    } catch (e) {
      window.console.log(e);
      return false;
    }
  }
  async logout() {
    const url = `${baseURL}/api/logout`;
    const result = await this.postWithAuth({
      url,
      bpdy: '',
      isError: status => status !== 200,
    });
    this.accessToken = undefined;
    return result;
  }
  async getSites() {
    const url = `${baseURL}/api/me`;
    return this.getWithAuth({
      url,
      isError: (status, data) => (status !== 200 || !data),
    });
  }
  async getIndustries() {
    const url = `${baseURL}/api/master_data`;
    return this.getWithAuth({
      url,
      isError: (status, data) =>
        (status !== 200 || !data || !('m_industries' in data) || !('m_sub_industries' in data)),
      wrap: data => ({ m_industries: data.m_industries, m_sub_industries: data.m_sub_industries }),
    });
  }
  async checkHost(host) {
    const url = `${baseURL}/api/check_host`;
    return this.postWithAuth({
      url,
      body: { host },
      isError: (status, data) => (status !== 200 || !data || !('available' in data)),
      wrap: data => data.available,
    });
  }
  async changeHost(siteId, host) {
    const url = `${baseURL}/api/sites/${siteId}/change_host`;
    return this.postWithAuth({
      url,
      body: { host },
      isError: (status, data) =>
        (status !== 200 || !data || data.length !== 1 || data[0].id !== siteId),
      wrap: data => data[0],
    });
  }
  async changeIndustries(siteId, industries) {
    const url = `${baseURL}/api/sites/${siteId}/change_industry`;
    return this.postWithAuth({
      url,
      body: industries,
      isError: (status, data) =>
        (status !== 200 || !data || data.length !== 1 || data[0].id !== siteId),
      wrap: data => data[0],
    });
  }
  async getS3UploadURL(siteId) {
    const url = `${baseURL}/api/sites/${siteId}/s3_files/upload_url`;
    return this.getWithAuth({
      url,
      isError: (status, data) => (status !== 200 || !data || !('s3_file_id' in data) ||
        !('put_presigend_url' in data)),
    });
  }
  async postS3Upload(siteId, s3FileId) {
    const url = `${baseURL}/api/sites/${siteId}/s3_files/${s3FileId}`;
    return this.postWithAuth({
      url,
      body: '',
      isError: (status, data) =>
        (status !== 200 || !data || !('url' in data) || !('upload_status' in data) || data.upload_status !== 'uploaded'),
      wrap: data => data.url,
    });
  }
  async getSiteInformation(siteId) {
    const url = `${baseURL}/api/sites/${siteId}/informations`;
    return this.getWithAuth({
      url,
      isError: (status, data) => (status !== 200 || !data),
    });
  }
  async postSiteInformation(siteId, siteInfo) {
    const url = `${baseURL}/api/sites/${siteId}/informations`;
    return this.postWithAuth({
      url,
      body: { informations: siteInfo },
      isError: status => (status !== 200 && status !== 204),
      wrap: () => true,
    });
  }
  async getTemplates() {
    const url = `${baseURL}/api/templates`;
    return this.getWithAuth({
      url,
      isError: (status, data) => (status !== 200 || !data),
    });
  }
  async getTemplateImages() {
    const url = `${baseURL}/api/template_images`;
    return this.getWithAuth({
      url,
      isError: (status, data) => (status !== 200 || !data),
    });
  }
  async getBusinessTemplateImages() {
    const url = `${baseURL}/api/business_information_template_images`;
    return this.getWithAuth({
      url,
      isError: (status, data) => (status !== 200 || !data),
    });
  }
  async getContacts(siteId) {
    const url = `${baseURL}/api/sites/${siteId}/contact_histories`;
    return this.getWithAuth({
      url,
      isError: (status, data) => (status !== 200 || !data),
    });
  }
  async postContactItems(siteId, body) {
    const url = `${baseURL}/api/sites/${siteId}/site_contact_items`;
    return this.postWithAuth({
      url,
      body,
      isError: status => status !== 200 && status !== 204,
      wrap: () => ({ data: true }),
      rescue: status => status === 400,
      rescueWrap: data => ({ data }),
    });
  }
  async createSite(host, templateId) {
    const url = `${baseURL}/api/sites/create`;
    return this.postWithAuth({
      url,
      body: { host, template_id: templateId },
      isError: (status, data) =>
        (status !== 200 || !data || data.length !== 1 || !('id' in data[0])),
      wrap: data => data[0],
    });
  }
  async changeTemplate(siteId, templateId) {
    const url = `${baseURL}/api/sites/${siteId}/change_template`;
    return this.postWithAuth({
      url,
      body: { template_id: templateId },
      isError: (status, data) =>
        (status !== 200 || !data || data.length !== 1 || data[0].id !== siteId),
      wrap: data => data[0],
    });
  }
  async changeOpenStatus(siteId, isOpen) {
    const url = `${baseURL}/api/sites/${siteId}/change_open_status`;
    return this.postWithAuth({
      url,
      body: { is_opened: isOpen },
      isError: (status, data) =>
        (status !== 200 || !data || data.length !== 1 || data[0].id !== siteId),
      wrap: data => data.find(x => x.id === siteId),
    });
  }
  async getPage(siteId, pageId) {
    const url = `${baseURL}/api/sites/${siteId}/pages/${pageId}/preview`;
    return this.getWithAuth({
      url,
      isError: (status, data) => status !== 200 || !data || !('preview_html' in data),
      wrap: data => data.preview_html,
    });
  }
  async getEditPage(siteId, pageId) {
    const url = `${baseURL}/api/sites/${siteId}/pages/${pageId}`;
    return this.getWithAuth({
      url,
      isError: (status, data) => status !== 200 || !data || !('template_html' in data),
      wrap: data => data.template_html,
    });
  }
  async postEditPage(siteId, pageId, updateType, html) {
    const url = `${baseURL}/api/sites/${siteId}/pages/${pageId}`;
    return this.postWithAuth({
      url,
      body: { update_type: updateType, html },
      isError: status => status !== 200,
    });
  }
  async getRole() {
    const url = `${baseURL}/api/me/role`;
    return this.getWithAuth({
      url,
      isError: (status, data) => (status !== 200 || !data || !('role' in data)),
      wrap: data => data.role,
    });
  }
  async getAdminRole() {
    const url = `${baseURL}/api/me/role`;
    return this.getWithAdmin({
      url,
      isError: (status, data) => (status !== 200 || !data || !('role' in data)),
      wrap: data => data.role,
    });
  }
  async adminLogin(username, password) {
    const loginResult = await this.login(username, password);
    if (!loginResult) {
      return false;
    }
    const role = await this.getRole();
    if (!role || (role !== 'superuser' && role !== 'admin')) {
      this.accessToken = undefined;
      return false;
    }
    this.adminToken = this.accessToken;
    this.accessToken = undefined;
    return true;
  }
  async adminLogout() {
    if (this.accessToken) {
      await this.logout();
    }
    const url = `${baseURL}/api/logout`;
    const result = await this.postWithAdmin({
      url,
      body: '',
      isError: status => status !== 200,
    });
    this.adminToken = undefined;
    return result;
  }
  async getUsers({ page, perPage, order, isDesc }, search, searchOwnerId) {
    const sort = isDesc ? 'desc' : 'asc';
    const searchQ = search ? `&q=${search}` : '';
    const ownerId = searchOwnerId ? `&owner_id=${searchOwnerId}` : '';
    const url = `${baseURL}/api/users?page=${page}&per_page=${perPage}&order=${order}&sort=${sort}${searchQ}${ownerId}`;
    return this.getWithAdmin({
      url,
      isError: (status, data) => (status !== 200 || !data),
    });
  }
  async getUserDetail(userId) {
    const basename = (userId === undefined) ? 'new' : `${userId}`;
    const url = `${baseURL}/api/users/${basename}`;
    return this.getWithAdmin({
      url,
      isError: (status, data) => (status !== 200 || !data || !('user_informations' in data)),
      wrap: data => data.user_informations,
    });
  }
  async postUserDetail(userId, body) {
    const basename = (userId === undefined) ? 'create' : `${userId}`;
    const url = `${baseURL}/api/users/${basename}`;
    return this.postWithAdmin({
      url,
      body,
      isError: status => status !== 200,
      wrap: () => ({ isError: false, data: true }),
      rescue: status => status === 400,
      rescueWrap: data => ({ isError: true, data }),
    });
  }
  async deleteUser(uid) {
    const url = `${baseURL}/api/users/${uid}`;
    const config = {
      headers: {
        authorization: `Bearer ${this.adminToken}`,
      },
    };
    try {
      const { status } = await Axios.delete(url, config);
      if (status !== 200) {
        return undefined;
      }
      return true;
    } catch (e) {
      window.console.log(e);
      return undefined;
    }
  }
  async simulateUser(userId) {
    const url = `${baseURL}/api/users/${userId}/token`;
    const result = await this.getWithAdmin({
      url,
      isError: (status, data) => (status !== 200 || !data || !('access_token' in data)),
      wrap: data => data.access_token,
    });
    if (!result) {
      return undefined;
    }
    this.accessToken = result;
    return true;
  }
  async exportUserCSV({ page, perPage, order, isDesc }, search, searchOwnerId) {
    const sort = isDesc ? 'desc' : 'asc';
    const searchQ = search ? `&q=${search}` : '';
    const ownerId = searchOwnerId ? `&owner_id=${searchOwnerId}` : '';
    const url = `${baseURL}/api/users/csv?page=${page}&per_page=${perPage}&order=${order}&sort=${sort}${searchQ}${ownerId}`;

    return this.getWithAdmin({
      url,
      isError: status => status !== 200,
    });
  }
  async importUserCSV(csv) {
    const url = `${baseURL}/api/users/csv`;
    const body = new FormData();
    body.append('file', csv);
    return this.postWithAdmin({
      url,
      body,
      isError: status => status !== 200,
      wrap: () => ({ isError: false, data: true }),
      rescue: status => status === 400,
      rescueWrap: data => ({ isError: true, data }),
    });
  }
  async getAdminContacts(sid) {
    const query = sid ? `?site_id=${sid}` : '';
    const url = `${baseURL}/api/contact_histories${query}`;
    return this.getWithAdmin({
      url,
      isError: (status, data) => (status !== 200 || !data),
    });
  }
  async getAdminContactMaster(sid) {
    const url = `${baseURL}/api/admin/sites/${sid}`;
    return this.getWithAdmin({
      url,
      isError: (status, data) =>
        (status !== 200 || !data || !('site_contact_items' in data)),
      wrap: data => data.site_contact_items,
    });
  }
  async getAdminAllContacts(year, month) {
    const url = `${baseURL}/api/contact_histories/csv?year=${year}&month=${month}`;
    return this.getWithAdmin({
      url,
      isError: status => status !== 200,
    });
  }
  async getCompanyPdf(siteId, designNumber) {
    const url = `${baseURL}/api/sites/${siteId}/pdf?designNumber=${designNumber}`;

    return getWithToken(this.accessToken, {
      url,
      config: { responseType: 'blob' },
      isError: status => status !== 200,
    });
  }
  async getAdminUsers({ page, perPage, order, isDesc }, search) {
    const sort = isDesc ? 'desc' : 'asc';
    const searchQ = search ? `&q=${search}` : '';
    const url = `${baseURL}/api/admin_users?page=${page}&per_page=${perPage}&order=${order}&sort=${sort}${searchQ}`;
    return this.getWithAdmin({
      url,
      isError: (status, data) => (status !== 200 || !data),
    });
  }
  async getAllAdminUsers() {
    const url = `${baseURL}/api/admin_users?per_page=10000`;
    return this.getWithAdmin({
      url,
      isError: (status, data) => (status !== 200 || !data),
    });
  }
  async getAdminUserDetail(userId) {
    const basename = (userId === undefined) ? 'new' : `${userId}`;
    const url = `${baseURL}/api/admin_users/${basename}`;
    return this.getWithAdmin({
      url,
      isError: (status, data) => (status !== 200 || !data || !('user_informations' in data)),
      wrap: data => data.user_informations,
    });
  }
  async postAdminUserDetail(userId, body) {
    const basename = (userId === undefined) ? 'create' : `${userId}`;
    const url = `${baseURL}/api/admin_users/${basename}`;
    return this.postWithAdmin({
      url,
      body,
      isError: status => status !== 200,
      wrap: () => ({ isError: false, data: true }),
      rescue: status => status === 400,
      rescueWrap: data => ({ isError: true, data }),
    });
  }
  async deleteAdminUser(uid) {
    const url = `${baseURL}/api/admin_users/${uid}`;
    const config = {
      headers: {
        authorization: `Bearer ${this.adminToken}`,
      },
    };
    try {
      const { status } = await Axios.delete(url, config);
      if (status !== 200) {
        return undefined;
      }
      return true;
    } catch (e) {
      window.console.log(e);
      return undefined;
    }
  }
  async getAdminSiteListCSV() {
    const url = `${baseURL}/api/admin_site_list_csv`;

    return this.getWithAdmin({
      url,
      isError: status => status !== 200,
    });
  }
}

export const uploadToS3 = async (url, imgFile) => {
  const config = {
    headers: {
      'Content-Type': imgFile.type,
    },
  };
  try {
    const { status } = await Axios.put(url, imgFile, config);
    if (status !== 200) {
      return undefined;
    }
    return true;
  } catch (e) {
    window.console.log(e);
    return undefined;
  }
};

export const sendResetEmail = async (email) => {
  const url = `${baseURL}/api/password_reset/create`;
  const config = {
    headers: {
    },
  };
  try {
    const { status } = await Axios.post(url, { email }, config);
    if (status !== 200 && status !== 404) {
      return undefined;
    }
    return status === 200;
  } catch (e) {
    window.console.log(e);
    return undefined;
  }
};

export const checkResetKey = async (key) => {
  const url = `${baseURL}/api/password_reset/check_key`;
  const config = {
    headers: {
    },
  };
  try {
    const { status } = await Axios.post(url, { key }, config);
    if (status !== 200) {
      return undefined;
    }
    return true;
  } catch (e) {
    window.console.log(e);
    return undefined;
  }
};

export const updatePassword = async (key, newPassword) => {
  const url = `${baseURL}/api/password_reset/update`;
  const config = {
    headers: {
    },
  };
  try {
    const payload = { key, new_password: newPassword };
    const { status } = await Axios.post(url, payload, config);
    if (status !== 200 && status !== 400) {
      return undefined;
    }
    return status === 200;
  } catch (e) {
    window.console.log(e);
    return undefined;
  }
};




// WEBPACK FOOTER //
// ./src/utils/Requests.js